import { render, staticRenderFns } from "./EOArchitectureWorkshop.vue?vue&type=template&id=19037fa8&"
import script from "./EOArchitectureWorkshop.vue?vue&type=script&lang=js&"
export * from "./EOArchitectureWorkshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports